import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_pricing_scheme_link_update_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_line_guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    event_properties: fromDatatype.JsonDatatypeInterface;
    fail_message: fromDatatype.VarcharDatatypeInterface;
    sales_unit_price: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    sales_max_price: fromDatatype.NumericDatatypeInterface;
    sales_min_price: fromDatatype.NumericDatatypeInterface;
    purchase_unit_price: fromDatatype.NumericDatatypeInterface;
    purchase_max_price: fromDatatype.NumericDatatypeInterface;
    purchase_min_price: fromDatatype.NumericDatatypeInterface;
    purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    validity_duration_in_day: fromDatatype.NumericDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    reward_point: fromDatatype.NumericDatatypeInterface;
    reward_point_enable: boolean;
    reward_point_operator: fromDatatype.VarcharDatatypeInterface;
    reward_point_ratio: fromDatatype.NumericDatatypeInterface;
    redeem_point: fromDatatype.NumericDatatypeInterface;
    redeem_point_enable: boolean;
    redeem_point_operator: fromDatatype.VarcharDatatypeInterface;
    redeem_point_ratio: fromDatatype.NumericDatatypeInterface;
    purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    execution_after: fromDatatype.TimestampTzDatatypeInterface;
    execution_expiry: fromDatatype.TimestampTzDatatypeInterface;
    number_of_retry: fromDatatype.NumericDatatypeInterface;
    max_retry: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_pricing_scheme_link_update_queue_RowClass implements bl_fi_pricing_scheme_link_update_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_line_guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    event_properties: fromDatatype.JsonDatatypeInterface;
    fail_message: fromDatatype.VarcharDatatypeInterface;
    sales_unit_price: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    sales_max_price: fromDatatype.NumericDatatypeInterface;
    sales_min_price: fromDatatype.NumericDatatypeInterface;
    purchase_unit_price: fromDatatype.NumericDatatypeInterface;
    purchase_max_price: fromDatatype.NumericDatatypeInterface;
    purchase_min_price: fromDatatype.NumericDatatypeInterface;
    purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
    sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    validity_duration_in_day: fromDatatype.NumericDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    reward_point: fromDatatype.NumericDatatypeInterface;
    reward_point_enable: boolean;
    reward_point_operator: fromDatatype.VarcharDatatypeInterface;
    reward_point_ratio: fromDatatype.NumericDatatypeInterface;
    redeem_point: fromDatatype.NumericDatatypeInterface;
    redeem_point_enable: boolean;
    redeem_point_operator: fromDatatype.VarcharDatatypeInterface;
    redeem_point_ratio: fromDatatype.NumericDatatypeInterface;
    purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
    sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    execution_after: fromDatatype.TimestampTzDatatypeInterface;
    execution_expiry: fromDatatype.TimestampTzDatatypeInterface;
    number_of_retry: fromDatatype.NumericDatatypeInterface;
    max_retry: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
